module.exports = __webpack_public_path__ + "img/质量预警.43872d58.svg";